export function getActiveUserInfo(state) {
  return state.activeUser;
}
